/**
 * Derives a route slug from the current URL for a log's "screen" field, for
 * the few call sites that have no React Router context to read from (the
 * redux error middleware, the class-based error boundary).
 * e.g. "/onboarding/connect-pms" -> "connect-pms", "/onboarding" -> "landing"
 */
const currentScreenSlug = () => {
  try {
    const path = window.location.pathname.replace(/^\/onboarding\/?/, '');
    return path || 'landing';
  } catch {
    return 'unknown';
  }
};

export default currentScreenSlug;
